import React, { useContext, useEffect, useState } from "react";
import { UBAppModal } from "../../../../../Libraries";
import { LanguageContext } from "../../../../../context/LanguageContext";
import { Box } from "@mui/material";
import { UBAppTabs } from "../../../../common";
import { useLocation } from "react-router-dom";
import { analytics, triggerLogEvent } from "../../../../../config/firebase";
import SortTabContent from "./SortTabContent";
import FilterTabContent from "./FIlterTabContent";

const FilterModal = ({
  isOpen = false,
  handleClose,
  setFilters,
  filter,
  isShowDateField = false,
  type,
}) => {
  const location = useLocation();
  const PaymentFilter = ["All", "Paid", "Unpaid"];
  const SortFilter = ["Recent", "Amount (High - Low)", "Amount (Low - High)"];
  const initialFilters = {
    payment: PaymentFilter[0],
    sort: SortFilter[0],
    range: [],
  };
  const [I18n] = useContext(LanguageContext);
  const [tabValue, setTabVal] = useState("filter");

  const [filterOp, setFilterOp] = useState(initialFilters);
  const handleClear = () => {
    setFilterOp({
      ...initialFilters,
    });
    setFilters({ ...initialFilters });

    if (type === "out") {
      triggerLogEvent(analytics, "pb_clear_filter");
    } else {
      triggerLogEvent(analytics, "inv_clear_filter");
    }
    handleClose();
  };

  const onFilterDate = (startDate = "", endDate = "") => {
    if (startDate && endDate)
      setFilterOp((f) => ({ ...f, range: [startDate, endDate] }));
    else setFilterOp((f) => ({ ...f, range: [] }));
  };

  useEffect(() => {
    if (filter) {
      setFilterOp({
        ...filter,
      });
    }
  }, [filter, isOpen]);

  const onApply = () => {
    if (isShowDateField)
      triggerLogEvent(
        analytics,
        type === "in" ? "inv_report_filter" : "pb_report_filter"
      );
    if (filter?.payment != filterOp?.payment && !isShowDateField)
      triggerLogEvent(analytics, type === "in" ? "inv_filter" : "pb_filter");
    if (filter?.sort != filterOp?.sort)
      triggerLogEvent(analytics, type === "in" ? "inv_sort" : "pb_sort");
    setFilters({ ...filterOp });
    handleClose();
  };

  const onChangeTab = (event, newValue) => {
    setTabVal(newValue);
    triggerLogEvent(
      analytics,
      newValue === "filter" ? "inv_filter" : "inv_sort"
    );
  };

  return (
    <UBAppModal
      id={type === "in" ? "inv_filter" : "pb_filter"}
      open={isOpen}
      handleClose={handleClose}
      className={"filterModal AccountFilter"}
      header={{
        CustomHeader: <></>,
        handleClose: () => {
          handleClose();
        },
      }}
      footer={[
        {
          data: {
            className: `newFontColor fontSize14 fontWeight400 textUppercase cursorPointer clear-btn`,
            title: `${I18n.clear} ${I18n.filter}`,
            onClick: () => handleClear(),
            id: type === "in" ? "inv_filter_clear" : "pb_filter_clear",
          },
        },
        {
          data: {
            className: `newFontColor fontSize14 fontWeight400 textUppercase cursorPointer apply-btn`,
            title: I18n.apply,
            onClick: onApply,
            id: type === "in" ? "inv_filter_apply" : "pb_filter_apply",
          },
        },
      ]}
    >
      <Box className="accountFilterModalBody">
        <UBAppTabs
          tabList={[
            { label: "filter", value: "filter" },
            { label: "sort", value: "sort" },
          ]}
          value={tabValue}
          handleChange={onChangeTab}
          variant="fullWidth"
        />
        <Box
          className={`accountFilterModalTabBody ${
            tabValue === "sort" ? "sortTabBody" : ""
          }`}
        >
          {tabValue === "filter" && (
            <FilterTabContent
              I18n={I18n}
              isShowDateField={isShowDateField}
              filterOp={filterOp}
              setFilterOp={setFilterOp}
              onFilterDate={onFilterDate}
            />
          )}
          {tabValue === "sort" && (
            <SortTabContent
              I18n={I18n}
              filterOp={filterOp}
              setFilterOp={setFilterOp}
            />
          )}
          {/* <div className="w-100">
            {isShowDateField && (
              <Fragment>
                <ParagraphText className="fontWeight700 fontSize16">
                  {I18n.date}
                </ParagraphText>
                <Box margin={"1.25rem 0"}>
                  <RangePicker
                    onFilterDate={onFilterDate}
                    rangeValue={filterOp.range}
                  />
                </Box>
              </Fragment>
            )}
            <ParagraphText className="fontWeight700 fontSize16">
              {I18n.filter}
            </ParagraphText>
            <div className="filterRadioOptionList marginTop20 invoicePayment">
              {PaymentFilter.map((pf, ind) => (
                <UBRadioBox
                  key={ind}
                  index={ind}
                  label={pf}
                  onChange={(value) => {
                    setFilterOp((f) => ({ ...f, payment: value }));
                  }}
                  value={filterOp.payment}
                />
              ))}
            </div>
            <ParagraphText className="fontWeight700 fontSize16">
              {I18n.sort}
            </ParagraphText>
            <div className="filterRadioOptionList marginTop20 invoiceSort">
              {SortFilter.map((pf, ind) => (
                <UBRadioBox
                  key={ind}
                  index={ind}
                  label={pf}
                  onChange={(value) => {
                    setFilterOp((f) => ({ ...f, sort: value }));
                  }}
                  value={filterOp.sort}
                />
              ))}
            </div>
          </div> */}
        </Box>
      </Box>
    </UBAppModal>
  );
};

export default FilterModal;
